import { render, staticRenderFns } from "./MedicineWrhsMngtDtl.vue?vue&type=template&id=5fdfc33e"
import script from "./MedicineWrhsMngtDtl.vue?vue&type=script&lang=js"
export * from "./MedicineWrhsMngtDtl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports